export enum OpenTrigger {
  FIX_BLOCK = "fix_block",
  AUTO_OPEN = "auto_open",
  SCROLL = "scroll",
  LEAVE = "leave",
  QUIZ_MODE_FULL = "full",
  QUIZ_MODE_CUSTOM = "custom",
  OTHER = "other"
}